import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import WhatIDo from './components/WhatIDo';
import Work from './components/Work';
import Contact from './components/Contact';
import SocialNav from './components/SocialNav';
import Footer from './components/Footer';
import Starfield from './components/Starfield';
import './styles/main.css';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    // Enable smooth scrolling
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Initialize GSAP ScrollTrigger
    ScrollTrigger.refresh();
    
    // Cleanup
    return () => {
      ScrollTrigger.killAll();
    };
  }, []);

  return (
    <div className="App">
      <Starfield />
      <Navbar />
      <main>
        <Hero />
        <About />
        <WhatIDo />
        <Work />
        <Contact />
      </main>
      <SocialNav />
      <Footer />
    </div>
  );
}

export default App;